import { useSelector } from 'react-redux';
import { PermissionName, ROLE, permissions } from '../common/constants';
import { userRoles } from '../routes/util';

export const usePermissions = () => {
  const userRole: ROLE = useSelector((state: any) => state.users.roleName);
  const userRoleName: ROLE = userRoles.filter((user) => user.id == userRole)[0]
    ?.displayName;
  const hasPermissions = (permissionName: PermissionName): boolean => {
    return permissions[permissionName].includes(userRoleName);
  };
  return { hasPermissions };
};
